import { Icons } from '../constants'

import PanelAdminComercio from '../views/comerciante/PanelAdminComercio.vue'

import BeneficiosComercio from '../components/panelComerciante/BeneficiosComercio.vue'
import DashboardComercio from '../components/panelComerciante/DashboardComercio.vue'
import DescuentosComercio from '../components/panelComerciante/DescuentosComercio.vue'
import HistorialVentas from '../components/panelComerciante/HistorialVentas.vue'
import Venta from '../components/panelComerciante/Venta.vue'
import VentasPendientesDeAprobacion from '../views/comerciante/VentasPendientesDeAprobacion/VentasPendientesDeAprobacion.vue'

export const RouteNames = {
  logIn: 'InicioLogin',
  HistorialVentas: 'historialVentasComerciante',
  Ventas: 'ventasComerciante',
  VoucherVenta: 'voucherVentaComerciante',
  VentasPendientesDeAprobacion: 'comerciante.venta.pending'
}

export const VistasMenuPanel = [
  {
    component: DescuentosComercio,
    path: '',
    name: RouteNames.Ventas,
    titulo: 'Ventas con +Beneficios',
    icono: Icons.PRECIO,
  },
  {
    component: DashboardComercio,
    path: 'miNegocio',
    name: 'datos',
    titulo: 'Mi Negocio',
    icono: Icons.COMERCIO,
  },
  {
    component: BeneficiosComercio,
    path: 'beneficios',
    name: 'beneficiosComercio',
    // Atributos de vista
    titulo: 'Configuración de +Beneficios',
    icono: Icons.DESCUENTO,
  },
  {
    component: HistorialVentas,
    path: 'historial',
    name: RouteNames.HistorialVentas,
    // Atributos de vista
    titulo: 'Historial',
    icono: Icons.HISTORIAL_VENTAS
  },
  {
    component: VentasPendientesDeAprobacion,
    path: 'ventasPendientes',
    name: RouteNames.VentasPendientesDeAprobacion,
    titulo: 'Ventas pendientes de aprobación',
    icono: Icons.VENTAS_WITH_PENDING_APPROVAL
  }
]

export const routes = [
  {
    path: '/comerciante',
    component: PanelAdminComercio,
    children: VistasMenuPanel,
  },
  // El voucher de venta no aparece en el menú pero es una ruta de comerciante
  {
    component: Venta,
    path: '/comerciante/venta',
    name: RouteNames.VoucherVenta,
    props: true,
  },
]
